var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCallIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_343_1547)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.5001 13.6002V15.8502C16.5009 16.0591 16.4581 16.2659 16.3745 16.4572C16.2908 16.6486 16.168 16.8204 16.0141 16.9616C15.8602 17.1028 15.6785 17.2103 15.4806 17.2773C15.2828 17.3442 15.0731 17.369 14.8651 17.3502C12.5572 17.0995 10.3403 16.3108 8.39257 15.0477C6.58044 13.8962 5.04407 12.3599 3.89257 10.5477C2.62506 8.59113 1.83625 6.36347 1.59007 4.04523C1.57133 3.83783 1.59598 3.6288 1.66245 3.43145C1.72892 3.2341 1.83575 3.05275 1.97615 2.89894C2.11654 2.74514 2.28743 2.62226 2.47792 2.53812C2.6684 2.45398 2.87433 2.41043 3.08257 2.41023H5.33257C5.69655 2.40665 6.04942 2.53554 6.32539 2.77288C6.60137 3.01022 6.78163 3.33981 6.83257 3.70023C6.92754 4.42028 7.10366 5.12727 7.35757 5.80773C7.45848 6.07617 7.48032 6.36791 7.4205 6.64839C7.36069 6.92886 7.22172 7.18631 7.02007 7.39023L6.06757 8.34273C7.13524 10.2204 8.68991 11.7751 10.5676 12.8427L11.5201 11.8902C11.724 11.6886 11.9814 11.5496 12.2619 11.4898C12.5424 11.43 12.8341 11.4518 13.1026 11.5527C13.783 11.8066 14.49 11.9828 15.2101 12.0777C15.5744 12.1291 15.9071 12.3126 16.145 12.5934C16.3828 12.8741 16.5092 13.2324 16.5001 13.6002Z",
    stroke: "#121212",
    strokeWidth: 1.47273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5381 2.41016C12.0668 2.57123 13.4947 3.24925 14.5857 4.33209C15.6768 5.41493 16.3655 6.83771 16.5381 8.36516",
    stroke: "#121212",
    strokeWidth: 1.47273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.5381 5.41016C11.2757 5.55561 11.9526 5.91943 12.4809 6.45439C13.0091 6.98935 13.3644 7.67075 13.5006 8.41016",
    stroke: "#121212",
    strokeWidth: 1.47273,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_343_1547"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0 0.910156)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallIcon);
export default __webpack_public_path__ + "static/media/call-icon.0dd2953263863c93b0c9e83f235f390a.svg";
export { ForwardRef as ReactComponent };